import {Component, OnInit} from '@angular/core';
import {BmCreditorObjectBaseComponent} from "../bm-creditor-object-base.component";


@Component({
    selector: 'bm-creditor-object-component-side',
    templateUrl: 'bm-creditor-object-side.component.html',
    standalone: false
})
export class BmCreditorObjectSideComponent extends BmCreditorObjectBaseComponent implements OnInit {


    /**
     * On Object Change. When object is retrieved
     */
    ngOnInit() {
        super.ngOnInit();
    }



}
